/**
 * Origem Flow: cache local das views por tabela, para o ⌘K oferecer
 * "Ir para Lumar · Quadro" mesmo fora da tabela (o store `view` só conhece
 * as views da tabela aberta). Preenchido sempre que uma tabela carrega as
 * views; vive no localStorage do navegador.
 */
const KEY = 'origemViewsByTable'

function read() {
  if (typeof localStorage === 'undefined') {
    return {}
  }
  try {
    return JSON.parse(localStorage.getItem(KEY) || '{}') || {}
  } catch {
    return {}
  }
}

export function cacheTableViews(tableId, views) {
  if (typeof localStorage === 'undefined' || !tableId) {
    return
  }
  try {
    const all = read()
    all[tableId] = (views || []).map((view) => ({
      id: view.id,
      name: view.name,
      type: view.type,
    }))
    localStorage.setItem(KEY, JSON.stringify(all))
  } catch {
    // Sem espaço/privado: o ⌘K só perde as views de outras tabelas.
  }
}

export function cachedViewsOf(tableId) {
  return read()[tableId] || []
}
